import { normalize, schema } from 'normalizr'
import { IMembership, ITemporary, IUpdateServiceMemberships } from '../types/'
import { IProgramServiceMembership, recordsPerPage } from '../types'
import { serverApi } from '../utils/request'
import Paths from '../utils/paths'

class MembershipService {
  private schemaProvider = new schema.Entity('provider')
  private schemaProviderProduct = new schema.Entity('providerProduct', {
    provider: this.schemaProvider
  })
  private schemaOrganization = new schema.Entity('organization')
  private schemaService = new schema.Entity('service', {
    organization: this.schemaOrganization,
    providerProducts: [this.schemaProviderProduct]
  })
  private schemaMembership = new schema.Entity(
    'membership',
    {
      service: this.schemaService
    },
    {
      processStrategy: entity => ({
        id: entity.id,
        eligibility: entity.type === 'PERMANENT' ? 'permanent' : 'temporary',
        isLimitedByDate: !!entity.beginsAt && !!entity.expiresAt,
        isLimitedByRecurringMonths: !!entity.recurringType,
        isLimitedByNumberOfRides: !!entity.ridesNum && !!entity.ridesRangeType,
        service: entity.service,
        beginsAt: new Date(entity.beginsAt),
        expiresAt: new Date(entity.expiresAt),
        recurringMonths: entity.recurringType && entity.recurringType.split(','),
        ridesNum: entity.ridesNum,
        ridesRangeType: entity.ridesRangeType,
        requestedAt: entity.requestedAt,
        isSuspended: false,
        suspensionUntil: new Date(),
        notAllowedPCA: entity.notAllowedPCA
      })
    }
  )

  public async getMembershipListByRiderId(riderId: string) {
    return await serverApi.get(`${Paths.rider.getOneWithMemberships}/${riderId}`).then(({ data }) => data)
  }

  public async updateRiderServiceMemberships(dto: IUpdateServiceMemberships) {
    return await serverApi.put(`${Paths.rider.updateRiderServiceMemberships}`, dto).then(({ data }) => data)
  }

  public async getMembershipListByRiderIdAndOrgId(riderId: string, orgId: string) {
    return await serverApi
      .get(Paths.serviceMembership.getManyByRiderIdAndOrgId, { params: { riderId, orgId } })
      .then(({ data }) => data)
  }

  public async fetchMembershipNewRequests(organizationId: string, page?: number): Promise<IProgramServiceMembership[]> {
    const result = await serverApi.get<IProgramServiceMembership[]>(Paths.serviceMembership.getNewRequests, {
      params: { organizationId, page, recordsPerPage }
    })
    return result.data
  }

  public async fetchMembershipProcessedRequests(
    organizationId: string,
    page?: number
  ): Promise<IProgramServiceMembership[]> {
    const result = await serverApi.get<IProgramServiceMembership[]>(Paths.serviceMembership.getProcessedRequests, {
      params: { organizationId, page, recordsPerPage }
    })
    return result.data
  }

  public updateMembershipStatus(data: ITemporary | string): Promise<IMembership[]> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject()
      }, 1000)
    })
  }
}

const membershipRequestService = new MembershipService()

export { membershipRequestService }



// WEBPACK FOOTER //
// ./src/services/MembershipRequest.ts